/**
 * Analytics Page
 *
 * Renders the advanced analytics dashboard using Chart.js.
 * Modernized to use shared components and DOM helpers (no large innerHTML templates).
 *
 * @package MultilingualPressZone
 */

import AnalyticsDashboard from '../sections/analytics-dashboard.js';

export default class AnalyticsPage {
    constructor(container) {
        this.container = container;
        this.analytics = null;
    }

    async render() {
        this.analytics = new AnalyticsDashboard(this.container, { layout: 'page', showHeader: true });
        await this.analytics.render();
    }

    destroy() {
        this.analytics?.destroy?.();
        this.analytics = null;
    }
}
